export const CORE_APPEARANCE = {
  containment: {
    label: 'CORE PHASE I · CONTAINMENT',
    name: 'CONTAINMENT',
    attackName: 'SIGNAL LASER',
    attackStyle: 'laser',
    missText: 'The signal laser passed you. No HP lost.',
    color: 0x713ec4,
    emissive: 0x4c1680,
    light: 0xd568ff,
    attack: 0xbd69ff,
    accent: 0x62eaff,
    hot: 0xf5edff,
    frameWidth: 4.6,
    laserPower: 1,
  },
  fracture: {
    label: 'CORE PHASE II · FRACTURED SHELL',
    name: 'FRACTURED SHELL',
    attackName: 'SHARD VOLLEY',
    attackStyle: 'shards',
    missText: 'The shard volley scattered past your signal. No HP lost.',
    color: 0x1688a5,
    emissive: 0x075e7c,
    light: 0x63ecff,
    attack: 0x4fe5ff,
    accent: 0xa9f8ff,
    hot: 0xe5fcff,
    frameWidth: 4.9,
    laserPower: 1.2,
    transitionTell: 'ARMOR INTEGRITY COMPROMISED',
    transitionName: 'THE SHELL FRACTURES',
  },
  emergence: {
    label: 'CORE PHASE III · EMERGING HEART',
    name: 'EMERGING HEART',
    attackName: 'ORBITAL PULSE',
    attackStyle: 'rings',
    missText: 'The pulse rings drifted past you and faded. No HP lost.',
    color: 0x9f2ea5,
    emissive: 0x75175e,
    light: 0xee85ff,
    attack: 0xf574df,
    accent: 0xffb3ec,
    hot: 0xffe8fa,
    frameWidth: 5.1,
    laserPower: 1.4,
    transitionTell: 'AN INNER SIGNAL BREAKS FREE',
    transitionName: 'THE HEART EMERGES',
  },
  evolution: {
    label: 'CORE PHASE IV · AWAKENED HEART',
    name: 'AWAKENED HEART',
    attackName: 'HEARTSEEKER ARCS',
    attackStyle: 'arcs',
    missText: 'The heartseeker arcs split away from your signal. No HP lost.',
    color: 0xa71f56,
    emissive: 0xa50d41,
    light: 0xff487e,
    attack: 0xff326d,
    accent: 0xff81b3,
    hot: 0xffe0d8,
    frameWidth: 5.2,
    laserPower: 1.6,
    transitionTell: 'SOMETHING INSIDE IS ALIVE',
    transitionName: 'THE HEART AWAKENS',
  },
  meltdown: {
    label: 'CORE PHASE V · FERAL HEART',
    name: 'FERAL HEART',
    attackName: 'RUPTURE PULSE',
    attackStyle: 'rupture',
    missText: 'The rupture pulse passed you. No HP lost.',
    color: 0x871827,
    emissive: 0xe52c12,
    light: 0xff692b,
    attack: 0xff501e,
    accent: 0xffc34e,
    hot: 0xfff0c2,
    frameWidth: 6.1,
    laserPower: 2.4,
    transitionTell: 'CRITICAL CONTAINMENT FAILURE',
    transitionName: 'FERAL HEART',
  },
};

export const getCoreAppearance = (phase) =>
  CORE_APPEARANCE[phase] || CORE_APPEARANCE.containment;

export const coreColorCss = (color) =>
  `#${color.toString(16).padStart(6, '0')}`;
